import React, { FC } from 'react';
import { IconProps } from '.';

export const LetterIcon: FC<IconProps> = ({ size = 24, ...props }) => {
    const sizing = { width: size, height: size };

    return (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...sizing} {...props}>
            <path
                stroke="currentColor"
                strokeWidth="1.5"
                d="M1.75 7.19c0-1.8 1.46-3.25 3.25-3.25h14c1.8 0 3.25 1.45 3.25 3.25v8.62c0 1.8-1.46 3.25-3.25 3.25H5a3.25 3.25 0 0 1-3.25-3.25V7.2Z"
            />
            <path stroke="url(#dfbe4170)" d="M4.5 16V7.56c0-.3.26-.56.58-.56m14.24.15c.11.1.18.26.18.41V16" />
            <path
                stroke="currentColor"
                d="M4.5 7.52c0-.29.24-.52.54-.52.14 0 .29.06.39.16l5 5.18a2.2 2.2 0 0 0 3.14 0l5-5.18c.2-.2.54-.22.76-.02.1.1.17.23.17.38"
            />
            <defs>
                <linearGradient id="dfbe4170" x1="14.31" x2="14.31" y1="9.25" y2="16" gradientUnits="userSpaceOnUse">
                    <stop stopColor="currentColor" />
                    <stop offset="1" stopColor="currentColor" stopOpacity="0" />
                </linearGradient>
            </defs>
        </svg>
    );
};
